import { useSelector, useDispatch } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router";
import { useEffect, useState } from "react";
// import { initializeApp, getApps } from "firebase/app";
// import {
//   getDatabase,
//   ref,
//   onValue,
//   onChildAdded,
//   onChildChanged,
//   off,
// } from "firebase/database";
// import { doc, onSnapshot, collection } from "firebase/firestore";
// import { ToastContainer, toast } from "react-toastify";

import Cookies from "js-cookie";
import { FaUserCircle } from "react-icons/fa";
import "./HubzuHeaderMenu.css";
import useAuth from "../../useAuth";
import UserDropDown from "../../UserDropDown";
import { getSavedSearchAndPropertyCount } from "@/api/savedSearch";
import {
  setSavedCount,
  showSavedTooltip,
} from "@/redux/savedpreference/savedPreferenceSlice";
import {
  setAlerts,
  // setAlertsCount,
  setProfileInfo,
  // setFirebaseConfig,
  setIsAlertsLoading,
} from "@/redux/user/userSlice";
// import { getWebCMS } from "@/api/PDP";
import { getUserProfile } from "@/api/myProfile";
import {
  setIsUserSubscribed,
  setLoginCallLocation,
  setLoginModal,
  setLoginTab,
  setShowContinueBtn,
  setShowSessionMsg,
} from "@/redux/login/loginSlice";
import LoginModal from "@/components/common/user-credentials/LoginModal";
import {
  resetPropertySubType,
  resetCategory,
  resetPropertyStatus,
  resetOccupancy,
  resetSpecialAssetsTypes,
  resetFeatured,
  addPriceMin,
  addPriceMax,
  addAreaMin,
  addAreaMax,
  addBuiltYearMin,
  addBuiltYearMax,
  addBathrooms,
  addBedrooms,
  addListingType,
  addNewToHubzu,
  addMarketingPhase,
  addAuctionEndingToday,
  addOwnItNow,
  addNobuyerpremium,
  addBrokerCoOp,
  addCashOnly,
  addCampaign,
  addCampaignId,
  addCampaignType,
  addIsPartOfCampaign,
  addOffers,
  addSearchBy,
  addMapParam,
} from "../../../../../redux/SRP/propertiesSlice";
import { getAlertData, resetMessageCount } from "@/api/alerts";
import { getCookie, setCookie } from "@/utils/cookies";
import SubscribedUser from "@/components/common/user-credentials/SubscribedUser";
import { store } from "@/store/store";
// import { alertsSummary } from "@/api/LoginSignup";
// import { inititaliseFirebase } from "@/components/common/FirebaseApp";
import {
  getEventCategory,
  trackApiCall,
  trackButtonClick,
} from "@/utils/analytics";
import { markInternalNavigation } from "@/utils/attributionCapture";
import { recentSearchLocalSave } from "../../saveSearchLocal";
import { handleSRPLogout } from "@/redux/SRP/srpSlice";
// import "react-toastify/dist/ReactToastify.css";

const HubzuHeaderMenu = ({ float = "" }) => {
  const firstName = "test";

  const dispatch = useDispatch();

  const navigate = useNavigate();
  const { pathname } = useLocation();

  const user = useSelector((state) => state.user);
  const globalPopup = useSelector((state) => state.login);
  const alerts = useSelector((state) => state.user.alerts);
  const savedCount = useSelector((state) => state.savedPreference);
  const alertsCount = useSelector((state) => state.user.alertsCount);
  const firebaseConfig = useSelector((state) => state.user.firebaseConfig);
  const webCMS = useSelector(
    (state) => state.cms?.data?.global?.results?.[0]?.["shared"]?.["navLinks"]
  );

  const state = store.getState();
  const userID = state?.user?.user?.realbidUserId;
  const { isUserLoggedIn, userName, userSignOut, userLastName } = useAuth();

  const [isLogin, setIsLogin] = useState();
  const [showTooltip, setShowTooltip] = useState(false);
  const [userSubscribed, setUserSubscribed] = useState(
    getCookie("subscribedUser") || false
  );

    const passwordExpired = useSelector((state) => state.user?.passwordExpired);



  const trackGAEvent = ({ name, source, category, label }) => {
    trackButtonClick({
      eventName: name,
      eventSource: source,
      eventCategory: category || getEventCategory(),
      eventLabel: label,
    });
  };

  // if(this.tenantId) {
  //     databaseUrl = this.tenantId + "/" + databaseUrl;
  // }
  // summaryNodeReference = self.firebaseApp.database().ref(databaseUrl);
  // console.log('myUserId -> ', myUserId);

  // useEffect(() => {
  //   if (!cmsData) {
  //     return;
  //   }
  //   setWebCMS(cmsData?.navLinks || []);
  // }, [cmsData]);

  // useEffect(() => {
  //    if (userID !== null | userID !== undefined || userID?.length > 0) {

  //     inititaliseFirebase(firebaseConfig?.qe);
  //    }
  //    const db = getDatabase();

  //   const starCountRef = ref(db, '/buy/users/' + userID + '/summary');
  //   const unsubscribe = onValue(starCountRef, (snapshot) => {

  //       const data = snapshot.val();
  //         console.log('summary snap -> ', data);
  //       const unReadMessageCount = snapshot.child('pendingMessages').val() || 0;
  //       dispatch(setAlertsCount(unReadMessageCount));
  //       const alertMessage = snapshot.child('lastMessage').val() || '';
  //       if (unReadMessageCount > 0) {
  //         const lastMessage = snapshot.child('lastMessage').val() || 0;
  //         if(lastMessage.length > 0){
  //         notifyUser(lastMessage);
  //         getAlertData().then((res) => {
  //           dispatch(setAlerts(res));
  //         });
  //         }

  //       }

  //   });
  //       onChildAdded(starCountRef, (snapshot) => {
  //       const data = snapshot.val();

  //        console.log('onChildAdded summary -> ', data);

  //     });

  //        onChildChanged(starCountRef, (snapshot) => {
  //       const data = snapshot.val();

  //        console.log('onChildChanges summary -> ', data);

  //     });

  //     const messageDb = ref(db, '/buy/users/' + userID + '/messages');

  //     onValue(messageDb, (snapshot) => {
  //       const data = snapshot.val();
  //         console.log('messageDb snap -> ', data);
  //     }
  //     );

  //     onChildChanged(messageDb, (snapshot) => {
  //       const data = snapshot.val();

  //        console.log('onChildChanged snap -> ', data);

  //     });

  //      onChildAdded(starCountRef, (snapshot) => {
  //       const data = snapshot.val();

  //        console.log('onChildAdded message -> ', data);

  //     });

  //  return () => {
  //     off(starCountRef); // Remove all listeners from this reference
  //   };// clean up listener on unmount
  // }, []);

  //   useEffect(() => {

  //     if (userID !== null | userID !== undefined || userID?.length > 0) {

  //       inititaliseFirebase(firebaseConfig?.qe);

  //       const db = getDatabase();
  //       const starCountRef = ref(db, '/buy/users/' + userID + '/summary');
  //       onValue(starCountRef, (snapshot) => {
  //         const data = snapshot.val();
  //           console.log('summary snap -> ', data);
  //         const unReadMessageCount = snapshot.child('pendingMessages').val() || 0;
  //         dispatch(setAlertsCount(unReadMessageCount));
  //         const alertMessage = snapshot.child('lastMessage').val() || '';
  //         if (unReadMessageCount > 0) {
  //           const lastMessage = snapshot.child('lastMessage').val() || 0;
  //           if(lastMessage.length > 0){
  //           notifyUser(lastMessage);
  //           getAlertData().then((res) => {
  //             dispatch(setAlerts(res));
  //           });
  //           }

  //         }

  //       });

  //        onChildAdded(starCountRef, (snapshot) => {
  //         const data = snapshot.val();

  //          console.log('onChildAdded summary -> ', data);

  //       });

  //          onChildChanged(starCountRef, (snapshot) => {
  //         const data = snapshot.val();

  //          console.log('onChildChanges summary -> ', data);

  //       });

  //       const messageDb = ref(db, '/buy/users/' + userID + '/messages');

  //       onValue(messageDb, (snapshot) => {
  //         const data = snapshot.val();
  //           console.log('messageDb snap -> ', data);
  //       }
  //       );

  //       onChildChanged(messageDb, (snapshot) => {
  //         const data = snapshot.val();

  //          console.log('onChildChanged snap -> ', data);

  //       });

  //        onChildAdded(starCountRef, (snapshot) => {
  //         const data = snapshot.val();

  //          console.log('onChildAdded message -> ', data);

  //       });

  // }

  //   },);

  // const notifyUser = (message) => {
  //   toast(message, {
  //     closeOnClick: true,
  //     autoClose: 1000,
  //     theme: 'colored',
  //     style: { background: '#fcf8e3', color:"black", textAlign:'center' },
  //   });
  // }

  const buyDropDown = [
    {
      id: 1,
      name: webCMS?.realEstateAuctions || "All Real Estate Auctions",
      routerPath: "/auctions?listingType=AUCN",
    },
    { id: 2, name: webCMS?.bankOwned || "Bank Owned", routerPath: "/bank-owned" },
    {
      id: 3,
      name: webCMS?.signatureSellerProperties || "Hubzu Signature Homes",
      routerPath: "/auctions?sid=signature-seller",
    },
    {
      id: 4,
      name: webCMS?.offMarketProperties || "Off Market Properties",
      routerPath: "/auctions?sid=offmarket-properties",
    },
    { id: 5, name: webCMS?.commercialProperties || "Commercial Properties", routerPath: "/commercial" },
    { id: 6, name: webCMS?.CWCOTSecondChance || "CWCOT Second Chance", routerPath: "/auctions?listingType=AUCN&category=secondchance" },
    { id: 7, name: webCMS?.foreclosure || "Foreclosure", routerPath: "/foreclosures" },
    { id: 8, name: webCMS?.shortSale || "Short Sale", routerPath: "/short-sale" },
    { id: 9, name: webCMS?.traditionalSale || "Traditional Sale", routerPath: "/traditional-sale" },
  ];
  const externalRoutes = ["/sell-a-home-in-an-online-auction/seller/"];
  const sellDropDown = [
    {
      id: 1,
      name: "Residential Properties",
      routerPath: "/sellahomeinanonlineauction",
    },
    { id: 2, name: "Commercial Properties", routerPath: "/sell-commercial" },
    // {
    //   id: 2,
    //   name: "Broker",
    //   routerPath: "/sell-a-home-in-an-online-auction/Broker-program",
    // },
  ];

  const handleAlertRefresh = () => {
    console.log("refreshed data");
    dispatch(setIsAlertsLoading(true));

    getAlertData()
      .then((res) => {
        dispatch(
          setAlerts({
            ...res,
            alerts: [...res?.alerts],
          })
        );
        // window.setAlertsLoading?.(false);
        dispatch(setIsAlertsLoading(false));
      })
      .catch((err) => {
        dispatch(setIsAlertsLoading(false));
      });
    resetMessageCount(userID);
    getUserProfile().then((pdata) => {
      dispatch(setProfileInfo(pdata?.data));
    });

    trackApiCall({
      eventName: "alerts_count_reset_success",
      eventCategory: "Global Alerts",
      eventSource: "on alert count refresh",
      eventLabel: getEventCategory(),
    });
  };

  const handleLoginClick = (e) => {
    e.preventDefault();
    dispatch(setShowSessionMsg(false));
    // navigate('/login-signup');
    if (pathname === "/") {
      // If on home page, navigate to login-signup page
      navigate("/register-sign-in");
      dispatch(setLoginTab("loginTab"));
      dispatch(setLoginCallLocation("login"));
    } else {
      // If not on home page, show login modal
      dispatch(setLoginModal(true));
      // do not change -- it is for sign in tab in global login popup
      dispatch(setLoginTab("loginTab"));
      dispatch(setLoginCallLocation("Popup"));
    }

    let eventCategory = getEventCategory();

    trackButtonClick({
      eventName: "header_register_sign_in_click",
      eventCategory: eventCategory,
      eventSource: "Header menu click",
      eventLabel: `Sign In`,
    });
  };

  const getAlertsCount = () => {
    if (isUserLoggedIn) {
      if (alerts?.idologyVerificationRequired === true) {
        return 1;
      } else {
        return alertsCount ? alertsCount : 0;
      }
    } else {
      return 1;
    }
  };

  const getSavedPreferenceCount = async () => {
    try {
      const data = await getSavedSearchAndPropertyCount(user.userEmailId);
      dispatch(setSavedCount({ count: data.SAVED_SEARCH_AND_PROPERTY_COUNT }));
    } catch (error) {
      console.log(error);
    }
  };

  const handleSignOut = () => {
    if (window.location.href.includes("my-shopper")) {
      setTimeout(() => {
        navigate("/");
        userSignOut({});
      }, 500);
    } else userSignOut({});
    dispatch(handleSRPLogout());
    localStorage.removeItem("recentSearch");
  };

  useEffect(() => {
    getSavedPreferenceCount();
  }, [savedCount.isAddedToSaved, isUserLoggedIn]);

  useEffect(() => {
    if (savedCount.isShowSavedTooltip) {
      setShowTooltip(true);
    }
  }, [savedCount.isShowSavedTooltip]);

  useEffect(() => {
    if (showTooltip) {
      setTimeout(() => {
        setShowTooltip(false);
        dispatch(showSavedTooltip(false));
      }, 2000);
    }
  }, [showTooltip]);

  useEffect(() => {
    if (globalPopup.isUserSubscribed) {
      setUserSubscribed(true);
    } else {
      setUserSubscribed(false);
    }
  }, [globalPopup.isUserSubscribed]);

  const resetAllFilters = () => {
    dispatch(resetPropertySubType());
    dispatch(resetCategory());
    dispatch(resetPropertyStatus());
    dispatch(resetOccupancy());
    dispatch(resetSpecialAssetsTypes());
    dispatch(resetFeatured());
    dispatch(addPriceMin(0));
    dispatch(addPriceMax(0));
    dispatch(addAreaMin(""));
    dispatch(addAreaMax(""));
    dispatch(addBuiltYearMin(0));
    dispatch(addBuiltYearMax(0));
    dispatch(addBedrooms(""));
    dispatch(addBathrooms(""));
    dispatch(addListingType({ value: "", isUpdate: false }));
    dispatch(addNewToHubzu({ value: "", isUpdate: false }));
    dispatch(addMarketingPhase({ value: "", isUpdate: false }));
    dispatch(addAuctionEndingToday({ value: "", isUpdate: false }));
    dispatch(addOwnItNow({ value: "", isUpdate: true }));
    dispatch(addNobuyerpremium({ value: "", isUpdate: true }));
    dispatch(addBrokerCoOp({ value: "", isUpdate: true }));
    dispatch(addCashOnly({ value: "", isUpdate: true }));
    dispatch(addCampaign({ value: "", isUpdate: false }));
    dispatch(addCampaignId({ value: "", isUpdate: false }));
    dispatch(addCampaignType({ value: "", isUpdate: false }));
    dispatch(addIsPartOfCampaign({ value: "", isUpdate: false }));
    dispatch(addOffers({ value: "", isUpdate: false }));
    dispatch(addSearchBy({ value: "", isUpdate: false }));
    dispatch(addMapParam(""));
  };

  useEffect(() => {
    const val = getCookie("subscribedUser");
    if (val === "true") {
      dispatch(setIsUserSubscribed(true));
    }
  }, []);

  return (
    <>
      <ul
        id="respMenu"
        className="ace-responsive-menu text-end d-lg-block d-none"
        data-menu-style="horizontal"
      >
        <li className="dropitem">
          <a
            href="#"
            id="header-buy-dropdown"
            className={
              buyDropDown.some(
                (page) =>
                  page.routerPath?.split("/")[1] === pathname?.split("/")[1]
                // page.routerPath?.split('/')[1] + "/[id]" === pathname?.split('/')[1]
              )
                ? "ui-active"
                : undefined
            }
          >
            <span id="header-buy-title" className="title">Buy</span>
            <span id="header-buy-arrow" className="arrow"></span>
          </a>
          <ul className="sub-menu ">
            {buyDropDown.map((item) => (
              <li key={item.id}>
                <Link
                  to={item.routerPath}
                  id={`header-buy-${item.name?.toLowerCase().replace(/\s+/g, '-')}`}
                  onClick={() => {
                    // if(item.routerPath === '/auctions?listingType=AUCN' || item.routerPath === '/auctions?sid=signature-seller' || item.routerPath === '/auctions?sid=offmarket-properties'){
                    resetAllFilters();
                    recentSearchLocalSave({
                      searchBy: null,
                      value: item.name,
                      searchURI: item?.routerPath,
                      isLoggedIn:
                        user.userEmailId || globalPopup?.isUserSubscribed,
                      isMenu: true
                    });
                    let eventCategory = getEventCategory();

                    trackButtonClick({
                      eventName: "header_click",
                      eventCategory: eventCategory,
                      eventSource: "Header menu click",
                      eventLabel: `Buy a home menu - ${item.name}`,
                    });

                    // Mark as internal navigation for SRP page mount tracking
                    markInternalNavigation();
                    // }
                  }}
                  className={
                    pathname?.split("/")[1] === item.routerPath?.split("/")[1]
                      ? // item.routerPath + "/[id]" === pathname?.split('/')[1]
                        "ui-active"
                      : undefined
                  }
                >
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>
        </li>
        {/* End .dropitem */}
        {/* <li className="last">
        <Link
          to="/about/about-us"
          className={pathname === "/about/about-us" ? "ui-active" : undefined}
        >
          About Us
        </Link>
      </li>
      <li className="last">
        <Link
          to="/sell"
          className={pathname === "/contact" ? "ui-active" : undefined}
      </li> */}
        <li className="dropitem">
          <a
            href="#"
            id="header-sell-dropdown"
            className={
              sellDropDown.some(
                (page) =>
                  page.routerPath?.split("/")[1] === pathname?.split("/")[1]
                // page.routerPath?.split('/')[1] + "/[id]" === pathname?.split('/')[1]
              )
                ? "ui-active"
                : undefined
            }
          >
            <span id="header-sell-title" className="title">Sell</span>
            <span id="header-sell-arrow" className="arrow"></span>
          </a>
          <ul className="sub-menu ">
            {sellDropDown.map((item) => (
              <li key={item.id}>
                {externalRoutes.includes(item.routerPath) ? (
                  <a href={item.routerPath} id={`header-sell-${item.name?.toLowerCase().replace(/\s+/g, '-')}`} className="your-link-classes">
                    {item.name}
                  </a>
                ) : (
                  <Link
                    to={item.routerPath}
                    id={`header-sell-${item.name?.toLowerCase().replace(/\s+/g, '-')}`}
                    onClick={() => {
                      let eventCategory = getEventCategory();
                      trackButtonClick({
                        eventName: "header_click",
                        eventCategory: eventCategory,
                        eventSource: "Header menu click",
                        eventLabel: `Buy a home menu - ${item.name}`,
                      });
                    }}
                    className={
                      pathname?.split("/")[1] === item.routerPath?.split("/")[1]
                        ? // item.routerPath + "/[id]" === pathname?.split('/')[1]
                          "ui-active"
                        : undefined
                    }
                  >
                    {item.name}
                  </Link>
                )}
              </li>
            ))}
          </ul>
        </li>
        <li className="last">
          <Link
            to="/blog"
            id="header-blog-link"
            target="_blank"
            className={pathname === "/blog" ? "ui-active" : undefined}
            onClick={() => {
              let eventCategory = getEventCategory();

              trackButtonClick({
                eventName: "header_blog_click",
                eventCategory: eventCategory,
                eventSource: "Header menu click",
                eventLabel: `Blog | visitorId: ${Cookies.get(
                  "visitorId"
                )}|userId: NA`,
              });
            }}
          >
            Blog
          </Link>
        </li>
        {(isUserLoggedIn || userSubscribed) && (
          <li className="last">
            <Link
              className=""
              id="header-saved-link"
              data-bs-toggle="offcanvas"
              data-bs-target="#ss"
              aria-controls="ss"
              onClick={() => {
                let eventCategory = getEventCategory();

                trackButtonClick({
                  eventName: "save_list_slider_open",
                  eventCategory: eventCategory,
                  eventSource: "Save slider open",
                });
              }}
            >
              Saved{" "}
              {savedCount?.savedCount && savedCount?.savedCount !== "0" ? (
                <div id="header-saved-count" className="savedCount">{savedCount.savedCount}</div>
              ) : null}
              {showTooltip && (
                <span id="header-saved-tooltip" className="save-search-tooltiptext">
                  1 item saved
                  <span id="header-saved-tooltip-arrow" className="save-search-tooltipArrow"></span>
                </span>
              )}
            </Link>
          </li>
        )}
        <li className="last">
          <Link
            className=""
            id="header-alerts-link"
            data-bs-toggle="offcanvas"
            data-bs-target="#alertsSidebarListing"
            aria-controls="alertsSidebarListing"
            onClick={() => {
              handleAlertRefresh();
              userSubscribed
                ? dispatch(setLoginTab("regsiterTab"))
                : dispatch(setLoginTab("loginTab"));
              dispatch(setLoginCallLocation("Alerts"));
            }}
          >
            {" "}
            Alerts{" "}
            {getAlertsCount() !== 0 ? (
              <div id="header-alerts-count" className="savedCount">{getAlertsCount()}</div>
            ) : null}
          </Link>
          {/* <ToastContainer
            className="toast-position"
            position="top-right"
            autoClose={5000}
            hideProgressBar
            newestOnTop={false}
            closeOnClick={false}
            rtl={false}
            closeButton={false}

          /> */}
        </li>
        {/* End .dropitem */}
        {(!isUserLoggedIn && !userSubscribed) || passwordExpired  ? (
          <li className={`list-inline-item list_s ${float}`}>
            <a
              href="#"
              id="header-login-link"
              data-bs-toggle=""
              data-bs-target=""
              onClick={(e) => handleLoginClick(e)}
            >
              {isLogin ? (
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div>
                    <FaUserCircle className={{ fontSize: "20px" }} />
                  </div>
                  <span>{firstName}</span>
                </div>
              ) : (
                <span
                  className="py-3 px-3 h-auto outline-0 login-signup-btn"
                  style={{
                    height: "40px",
                    border: "1px solid  #ADC4DA",
                    borderRadius: "10px",
                  }}
                >
                  Register/Sign In
                </span>
              )}
            </a>
          </li>
        ) : (
          <>
            <li className="dropitem">
              <a
                href="#"
                id="header-user-dropdown"
                onClick={() => {
                  trackButtonClick({
                    eventName: "my_account",
                    eventCategory: "User Profile",
                    eventSource: "My Account Click",
                  });
                }}
              >
                <span id="header-user-info">
                  <span id="header-user-initials" className="user-initials">
                    {userSubscribed ? (
                      "NU"
                    ) : (
                      <>
                        {userName?.charAt(0)}
                        {userLastName?.charAt(0)}
                      </>
                    )}
                  </span>
                  {userSubscribed ? "New User" : <>{userName}</>}
                </span>
                <span id="header-user-arrow" className="arrow"></span>
              </a>
              <ul className="sub-menu ">
                <div className="scroll-div">
                  {userSubscribed ? (
                    <>
                      <li>
                        <p className="p-1 subscribe-item">
                          Please can you complete your profile for better
                          experiences Complete your profile
                          <button
                            className="hubzu-btn-thm p-2 mt-2 subs-btn"
                            id="header-complete-profile-btn"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#subscribeUserProfile"
                            aria-controls="subscribeUserProfile"
                            onClick={() => {
                              dispatch(setLoginTab("regsiterTab"));
                              dispatch(setLoginCallLocation("Alerts"));
                              dispatch(setShowContinueBtn(true));

                              trackGAEvent({
                                name: "complete_your_profile_click",
                                source: "Complete your profile",
                                label: "Clicked on the Contiue to Registration",
                              });
                            }}
                          >
                            Complete Your profile
                          </button>
                        </p>
                      </li>{" "}
                    </>
                  ) : (
                    <>
                      <UserDropDown userType={user.userType} user={user.user} onSignOut={handleSignOut} />
                    </>
                  )}
                </div>
              </ul>
            </li>
          </>
        )}
        {globalPopup?.loginModal && (
          <LoginModal popUpMsg={globalPopup?.showSessionMsg} />
        )}

        {/* End .dropitem */}
      </ul>
      <div
        className="offcanvas offcanvas-end offcanvas-listing-sidebar"
        // tabIndex="-1"
        id="subscribeUserProfile"
        data-bs-scroll="true"
        data-bs-backdrop="false"
      >
        <SubscribedUser />
      </div>
    </>
  );
};

export default HubzuHeaderMenu;
